import api from "../axiosIntercepture";

export const fetchHsn = async(page, pageSize ) => {
    try {
        const response = await api.post(`/hsn/fetch?page=${page+1}&limit=${pageSize}`);

        if (!response.data?.success) {
            throw new Error(response.data?.message || "Failed to fetch HSN");
        }
        return response.data;
    } catch (err) {
        console.error("Error fetching HSN:", err);
         throw err?.response;
    }
  }

  export const fetchHsnById = async(id) => {
    try {
        const response = await api.post("/hsn/fetch-id/" + id);
        if (!response.data?.success) {
            throw new Error(response.data?.message || "Failed to fetch HSN"); 
        }
        return response.data.data;
    } catch (err) {
        console.error("Error fetching HSN by ID:", err);
        throw err?.response;
    }   
  }

